<template>

<div class="open">

	<div class="open-content">

		<router-link :to="{name: 'Home'}" class="open-exit"></router-link>

		<com-head :section="section" />

		<com-input :manual="true" :input="localInputs.first" v-on:change="onFirstChange" />
		<com-input :manual="true" :input="localInputs.last" v-on:change="onLastChange" />
		<com-input :manual="true" :input="localInputs.id" v-on:change="onIDChange" />

		<button class="open-search" v-on:click="onSearchClick">Search</button>

		<table class="open-results" v-if="is.searching">

			<thead v-if="results.length">

				<tr>
					<th>First Name</th>
					<th>Last Name</th>
					<th>Patient ID</th>
					<th></th>
				</tr>

			</thead>

			<tbody>

				<tr class="open-results-item" v-for="(profile, key) in results" :key="key">

					<td>{{ profile[index.firstname] }}</td>
					<td>{{ profile[index.lastname] }}</td>
					<td>{{ profile[index.id] }}</td>
					<td valign="middle"><div class="open-options"><div class="open-choose" v-on:click="onOpenClick(profile.key)">></div><div class="open-delete" v-on:click="onDeleteClick(profile.key)">x</div></div></td>

				</tr>

				<tr v-if="!results.length">

					<td class="open-results-empty" colspan="4">No matching profiles found.</td>

				</tr>

			</tbody>

		</table>

	</div>
	
</div>

</template>

<script>

import comHead from './../common/section/Head'
import comInput from './../common/section/form/Input'

export default {

	components: {

		'com-head': comHead,
		'com-input': comInput

	},

	data: function() {

		return {

			profiles: {},

			is: {
				searching: false
			},

			inputValues: {
				firstname: '',
				lastname: '',
				id: ''
			},

			search: {
				firstname: '',
				lastname: '',
				id: ''
			},

			section: {
				text: {
					title: 'Open existing profile'
				}
			},

			localInputs: {
				first: {
					manual: true,
					long: true,
					type: this.$constants.input.type.textbox,
					text: {
						label: 'First Name',
						placeholder: 'Optional'
					}
				},
				last: {
					manual: true,
					long: true,
					type: this.$constants.input.type.textbox,
					text: {
						label: 'Last Name',
						placeholder: 'Optional'
					}
				},
				id: {
					manual: true,
					long: true,
					type: this.$constants.input.type.textbox,
					text: {
						label: 'ID',
						placeholder: 'Optional'
					}
				}
			}

		}

	},

	created: function() {

		this.profiles = JSON.parse(this.$cookies.getItem('copd_profiles'))

	},

	computed: {

		index: function() {

			return {
				firstname: this.$store.getters['data/setup/profile/firstname'],
				lastname: this.$store.getters['data/setup/profile/lastname'],
				id: this.$store.getters['data/setup/profile/id']
			}

		},

		results: function() {

			var results = []

			this.$_.each(this.profiles, function(profile, key) {

				profile.key = key

				if (this.search.firstname || this.search.lastname || this.search.id) {

					if (this.search.firstname && profile[this.index.firstname].toLowerCase().indexOf(this.search.firstname.toLowerCase()) !== -1) {

						results.push(profile)

					} else if (this.search.lastname && profile[this.index.lastname].toLowerCase().indexOf(this.search.lastname.toLowerCase()) !== -1) {

						results.push(profile)

					} else if (this.search.id && profile[this.index.id].toLowerCase() === this.search.id) {

						results.push(profile)

					}
			
				} else {

					results.push(profile)

				}

			}.bind(this))

			return results

		}

	},

	methods: {

		onOpenClick: function(key) {

			this.$store.commit('session/values/all', this.profiles[key])
			this.$store.commit('session/profile', key)

		},

		onDeleteClick: function(deleteKey) {

			var newprofiles = {}

			this.$_.each(this.profiles, function(profile, key) {

				if (deleteKey !== key) newprofiles[key] = profile

			})

			this.profiles = newprofiles

			this.$cookies.setItem('copd_profiles', JSON.stringify(newprofiles))

		},

		onSearchClick: function() {

			this.search.firstname = this.inputValues.firstname
			this.search.lastname = this.inputValues.lastname
			this.search.id = this.inputValues.id

			this.is.searching = true

		},

		onFirstChange: function(value) {

			this.inputValues.firstname = value

		},

		onLastChange: function(value) {

			this.inputValues.lastname = value

		},

		onIDChange: function(value) {

			this.inputValues.id = value

		}

	}

}

</script>

<style scoped>

.open {
	position: absolute;
	left: calc(50% - 350px);
	right: 0px;
	top: 0px;
	height: 100%;
	overflow-y: auto;
	z-index: 1;
}

.open-exit {
	position: absolute;
	right: 25px;
	top: 20px;
	width: 48px;
	height: 48px;
	cursor: pointer;
	background-image: url(~@/assets/exit.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
	z-index: 1000;
}

.is-mobile .open-exit {
	right: 5px;
	top: 5px;
}

.is-tablet .open {
	left: 64px;
}

.is-mobile .open {
	left: 40px;
}

.open-content {
	width: 950px;
	padding: 90px;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}

.is-tablet .open-content {
	width: 100%;
}

.is-mobile .open-content {
	width: 100%;
	padding: 32px 8px 32px 32px;
}

.open-search {
	margin: 0px 10px;
	min-width: 150px;
	padding: 0px 20px;
	height: 48px;
	border-radius: 24px;
	border: 2px solid var(--primary-color);
	font-size: 18px;
	font-weight: 700;
	color: #343434;
	transition: all 300ms ease-in-out;
	width: 240px;
	margin: 0px auto;
	margin-top: 20px;
}

.is-mobile .open-search {
	width: 100%;
	margin: 0px 0px 10px 0px;
	min-height: 32px;
	line-height: 18px;
	font-size: 14px;
	padding: 0px 10px;
	border-radius: 16px;
}

.open-search:hover {
	background-color: var(--primary-color);
	color: #fff;
}

.open-results {
	margin-top: 48px;
	width: 100%;
	border-spacing: 0px 10px;
	border-collapse: initial;
}

.open-results td,
.open-results th {
	padding: 0px 4px 0px 0px;
	font-size: 14px;
	line-height: 40px;
	text-align: left;
}

.open-results th {
	padding-left: 20px;
	font-weight: 600;
}

.open-results td {
	padding-left: 20px;
	background-color: #f6f6f6;
	margin-bottom: 10px;
}

.open-results td:first-child {
	border-radius: 20px 0px 0px 20px;
}

.open-results td:nth-child(3) {
	border-radius: 0px 20px 20px 0px;
}

.open-results td:last-child {
	background-color: #fff;
	width: 64px;
}

td.open-results-empty {
	background-color: #fff;
	text-align: center;
	font-size: 20px;
	color: #666;
}

.open-options {
	display: flex;
	flex-direction: row;
}

.open-choose {
	background-color: var(--primary-color);
	width: 32px;
	height: 32px;
	border-radius: 16px;
	display: inline-block;
	text-align: center;
	cursor: pointer;
	color: #fff;
	font-size: 16px;
	font-weight: 600;
	line-height: 32px;
}

.open-delete {
	background-color: #eb4c4c;
	width: 32px;
	height: 32px;
	border-radius: 16px;
	display: inline-block;
	text-align: center;
	margin-left: 10px;
	cursor: pointer;
	color: #fff;
	font-size: 16px;
	font-weight: 600;
	line-height: 32px;
}

</style>